import { useSession } from "../session";

/**
 * Liens d'export d'un exercice (EF-2005). Un simple lien suffit : le cookie
 * de session accompagne la requête, et le serveur consigne l'export dans la
 * piste d'audit.
 */
export function LiensDExport({ exercice, formats }: { exercice: string; formats: ("fec" | "ecritures" | "grand-livre" | "balance")[] }) {
  const { peut } = useSession();
  if (!peut("EXPORTER_DONNEES")) return null;
  const base = `/api/exercices/${exercice}/exports`;
  const liens = {
    fec: { href: `${base}/fec`, libelle: "FEC", titre: "Fichier des écritures comptables : format ouvert, pièces validées" },
    ecritures: { href: `${base}/ecritures.csv`, libelle: "Écritures CSV", titre: "Toutes les lignes validées, sceau et lettrage compris" },
    "grand-livre": { href: `${base}/grand-livre.csv`, libelle: "Grand livre CSV", titre: "Pièces validées, solde cumulé par compte" },
    balance: { href: `${base}/balance.csv`, libelle: "Balance CSV", titre: "Pièces validées" },
  };
  return (
    <span className="liens-d-export">
      Exporter :{" "}
      {formats.map((format) => (
        <a key={format} href={liens[format].href} title={liens[format].titre} className="tertiaire">
          {liens[format].libelle}
        </a>
      ))}
    </span>
  );
}
